module.exports = __webpack_public_path__ + "img/badge_cinema.259f8395.jpg";